import React, {Component, Fragment, useEffect, useState} from 'react'
import DonationButton from "../components/donation-button";
import TeamSection from "../components/team-section";
import TeamDonSection from "../components/team-don-section";
import CustomSection from "../components/custom-section";
import {t} from "@lingui/core/macro";

export default function ContentTabs({context,campagneData,campagneTarget}){

    const isMobile=context.isMobile

    let sections=Array.isArray(campagneData?.config?.sections)?campagneData.config.sections:[]
    sections=sections.filter(i=>i.type==="SECTION" && !i.hidden)
    if(Array.isArray(campagneData?.teams) && campagneData.teams.some(i=>!i.hidden)){
        sections.push({id:"TEAMS",type:"TEAMS",label:t`Équipes`})
    }

    const [selectedSection, setSelectedSection] = useState(sections.length>0?sections[0]:null)


    if(sections.length===0){
        return null
    }

    return (
        <Fragment>
            <div className={"tabs"} style={{display:"flex",flexDirection:isMobile?"column":"row",alignItems:"center",gap:20}}>
                {sections.map(s=>{
                    const isSelected = selectedSection?.id === s.id

                    return(
                        <span
                            className={isSelected?"tabs-item-selected":"tabs-item"}
                            style={{borderRadius:5,fontSize:16,padding:"5px",fontWeight:"600",cursor:"pointer"}}
                            onClick={()=>setSelectedSection(s)}
                        >{s.label}
                        </span>
                    )
                })}
            </div>

            <div style={{marginTop:20,minHeight:isMobile?"50vh":"initial"}}>

                {sections.map(s=>{
                    const isSelected = selectedSection?.id === s.id

                    if(s.type=== "TEAMS")
                    {
                        return (
                            <div style={{display:isSelected?"block":"none"}}>
                                <TeamSection context={context} campagneData={campagneData} campagneTarget={campagneTarget}/>
                            </div>
                        )
                    }


                    if(s.type=== "SECTION")
                    {
                        return (
                            <div style={{display:isSelected?"block":"none"}}>
                                <CustomSection id={selectedSection.id} section={selectedSection} context={context} campagneData={campagneData} campagneTarget={campagneTarget}/>
                            </div>
                        )
                    }

                    return null
                })}
            </div>
        </Fragment>
    )

}
